import { FeatureCollection } from 'geojson'

interface GeojsonifyProp {
  geojson?: FeatureCollection
}

const geojsonify = <P extends object>(
  Component: React.ComponentType<P & { geojson: FeatureCollection }>
) => {
  return (props: P & GeojsonifyProp) => {
    const { geojson, ...rest } = props

    if (!geojson) {
      return null
    }

    return (
      <Component
        geojson={geojson}
        {...(rest as P)}
      />
    )
  }
}

export { geojsonify }
